import React from "react";

import { useTranslation, Trans } from "react-i18next";

function Table () {

    const { t } = useTranslation();

    const accountData = [
    {
        title: "account.10",
        values: ["$450", "$750+", "$1,000+", "$5,000+", "$10,000+"],
    },
    {
        title: "account.11",
        values: ["up to 500", "up to 500", "up to 500", "up to 500", "up to 500"],
    },
    {
        title: "account.12",
        values: ["40%", "40%", "40%", "40%", "40%"],
    },
    {
        title: "account.13",
        values: ["20%", "20%", "20%", "20%", "20%"],
    },
    {
        title: "account.14",
        values: ["-", "-", "10%", "20%", "20%+"],
    },
    {
        title: "",
        values: [
        "account.15",
        "account.16",
        "account.17",
        "account.18",
        "account.19",
        ],
    },
    {
        title: "",
        values: [
        "account.20",
        "account.21",
        "account.22",
        "account.23",
        "account.24",
        ],
    },
    {
        title: "",
        values: [
        "account.25",
        "account.26",
        "account.27",
        "account.28",
        "account.29",
        ],
    },
    {
        title: "",
        values: [
        "account.30",
        "account.31",
        "account.32",
        "account.33",
        "account.34",
        ],
    },
    ];

    const accountTypes = ["Bronze", "Silver", "Gold", "Platinum", "Diamond"];
    const rowColors = ["bg-white", "bg-[#EDE9E9]"];
      
    return(
        <div className="overflow-hidden relative pt-[80px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto">
               <div className="overflow-x-auto p-4">
                    <table className="w-full text-sm text-left open-sans">
                        <thead className="w-">
                            <tr className="bg-[#0BD752] text-white border-b border-[#0000004D]">
                                <th className="px-4 py-2">{t('account.4')}</th>
                                {accountTypes.map((type, index) => (
                                <th key={index} className="px-4 py-2">
                                    {type}
                                </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                        {accountData.map((row, rowIndex) => (
                            <tr
                            key={rowIndex}
                            className={rowColors[rowIndex % rowColors.length]}
                            >
                            <td className="px-4 py-2 border-b border-[#0000004D] font-semibold xl:w-[300px]">
                                {t(row.title) || ""}
                            </td>
                            {row.values.map((value, colIndex) => (
                                <td key={colIndex} className="px-4 py-2 border-b border-[#0000004D]">
                                    {t(value)}
                                </td>
                            ))}
                            </tr>
                        ))} 
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Table;